export const COMPANY: 'INK' | 'GAZ' | 'GEO' | 'EPERFORM' = (() => {
  const logoVariable = window._env_.REACT_APP_COMPANY || process.env.REACT_APP_COMPANY;

  if (logoVariable === 'INK') return 'INK';
  if (logoVariable === 'GAZ') return 'GAZ';
  if (logoVariable === 'GEO') return 'GEO';
  return 'EPERFORM';
})();
